import { isArray, isDefined, isUndefined } from '../../../utils/isDefined';

const mapFeatures = ({ subscription, simcards }) => {
  const subFeatures = subscription?.features;

  if (!isArray(subFeatures)) {
    return {};
  }

  const phoneAndSimcardFeatures = subFeatures.filter(
    feature => feature?.key === 'phone-and-sim-card'
  );

  if (isUndefined(phoneAndSimcardFeatures)) {
    return {};
  }

  const simcardsFeatureAttributes =
    phoneAndSimcardFeatures?.[0]?.featureAttributes;

  if (isUndefined(simcardsFeatureAttributes)) {
    return {};
  }

  let extraSimcards = {};

  for (let i = 1; i <= 3; i++) {
    const simcardExtra = mapExtrasimcard({
      simcardsFeatureAttributes,
      key: `extra-${i}`,
      simcards
    });

    if (Object.keys(simcardExtra).length > 0) {
      extraSimcards = { ...extraSimcards, [`extra-${i}`]: simcardExtra };
    }
  }

  return extraSimcards;
};

export default mapFeatures;

const mapExtrasimcard = ({ simcardsFeatureAttributes, key, simcards }) => {
  let simcardExtra = {};
  const extraSimcardResources = simcardsFeatureAttributes.find(
    attribute =>
      attribute.key.includes(key) &&
      attribute.key.includes('resources-sim-cards')
  );

  if (
    isDefined(extraSimcardResources) &&
    isDefined(extraSimcardResources.value)
  ) {
    simcardExtra = {
      icc: extraSimcardResources.value
    };
  }

  const extraNumberResources = simcardsFeatureAttributes.find(
    attribute =>
      attribute.key.includes(key) &&
      attribute.key.includes('resources-phone-numbers')
  );

  if (
    isDefined(extraNumberResources) &&
    isDefined(extraNumberResources.value)
  ) {
    simcardExtra = {
      ...simcardExtra,
      msisdn: extraNumberResources.value
    };
  }

  if (isDefined(simcardExtra.icc)) {
    const simcardsData = simcards.find(
      simcard => simcard.icc === simcardExtra.icc
    );

    if (isDefined(simcardsData)) {
      simcardExtra = {
        ...simcardExtra,
        ...simcardsData
      };
    }
  }

  return simcardExtra;
};

export const DESCRIPTION_FIELD_OPTIONS = {
  labelIntlKey: 'DESCRIPTION',
  tooltipIntlKey: 'TOOLTIP.EDIT_DESCRIPTION',
  editDialogLabelIntlKey: 'SIM_CARD.EDIT_DESCRIPTION',
  updateSuccessIntlKey: 'MESSAGE.UPDATE_SIMCARD_DESCRIPTION',
  field: 'description',
  maxTextLength: 35
};
